/**
 * Generated by Orval
 * Do not edit manually.
 */
import type {
  GetStudentVerificationStatus200,
  PostSubscriptionAccountNumber200,
  PostSubscriptionAccountNumberParams,
} from '../index.schemas.ts';

import { useApiFetch } from '../../../composables/useApiFetch.ts';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary update de betaalmethode naar incasso en bewaar de iban
 */
export const postSubscriptionAccountNumber = (
  params: PostSubscriptionAccountNumberParams,
  options?: SecondParameter<typeof useApiFetch<PostSubscriptionAccountNumber200>>,
) => {
  return useApiFetch<PostSubscriptionAccountNumber200>(
    { url: `/front-office/v1/aanvraag/rekeningnummer`, method: 'POST', params },
    options,
  );
};
/**
 * @summary Get business hours by type and brand
 */
export const getBusinessHours = (
  type: 'shops' | 'retention',
  brand:
    | 'ad'
    | 'ari'
    | 'atr'
    | 'aut'
    | 'babn'
    | 'barn'
    | 'baun'
    | 'bd'
    | 'bdan'
    | 'bdon'
    | 'bfwo'
    | 'bladcadeau'
    | 'bladenhuis'
    | 'blbn'
    | 'bmgn'
    | 'bs'
    | 'bsvw'
    | 'bvwo'
    | 'bwol'
    | 'da'
    | 'dat'
    | 'dde'
    | 'ddj'
    | 'dg'
    | 'dm'
    | 'don'
    | 'donex'
    | 'donpo'
    | 'donsp'
    | 'ed'
    | 'ehi'
    | 'flbe'
    | 'flnl'
    | 'flr'
    | 'flwsp'
    | 'GENERIC'
    | 'gg'
    | 'hl'
    | 'hp'
    | 'hu'
    | 'katri'
    | 'kiosk'
    | 'kioskbe'
    | 'kwe'
    | 'lib'
    | 'libbo'
    | 'libbp'
    | 'libpz'
    | 'libsp'
    | 'linda'
    | 'lossebladen'
    | 'mar'
    | 'marbk'
    | 'marbp'
    | 'marpl'
    | 'marpp'
    | 'marpz'
    | 'marsp'
    | 'nouhp'
    | 'oudzs'
    | 'ovn'
    | 'pak12'
    | 'primo'
    | 'pz'
    | 'st'
    | 'sto'
    | 'storybe'
    | 'svw'
    | 'tr'
    | 'tsbe'
    | 'tt'
    | 'tta'
    | 'tvblad'
    | 'tvfam'
    | 'vivam'
    | 'vk'
    | 'vro'
    | 'vtw'
    | 'wls'
    | 'zvk',
  options?: SecondParameter<typeof useApiFetch<unknown>>,
) => {
  return useApiFetch<unknown>({ url: `/front-office/v1/business-hours/${type}/${brand}`, method: 'GET' }, options);
};
/**
 * @summary Get business hours by type
 */
export const getBusinessHoursV2 = (
  type: 'shops' | 'retention',
  options?: SecondParameter<typeof useApiFetch<unknown>>,
) => {
  return useApiFetch<unknown>({ url: `/front-office/v2/business-hours/${type}`, method: 'GET' }, options);
};
/**
 * @summary Get student verification status by verification id
 */
export const getStudentVerificationStatus = (
  options?: SecondParameter<typeof useApiFetch<GetStudentVerificationStatus200>>,
) => {
  return useApiFetch<GetStudentVerificationStatus200>(
    { url: `/front-office/v1/student-verification-status`, method: 'GET' },
    options,
  );
};
export type PostSubscriptionAccountNumberResult = NonNullable<
  Awaited<ReturnType<typeof postSubscriptionAccountNumber>>
>;
export type GetBusinessHoursResult = NonNullable<Awaited<ReturnType<typeof getBusinessHours>>>;
export type GetBusinessHoursV2Result = NonNullable<Awaited<ReturnType<typeof getBusinessHoursV2>>>;
export type GetStudentVerificationStatusResult = NonNullable<Awaited<ReturnType<typeof getStudentVerificationStatus>>>;
